import { Pipe, PipeTransform } from '@angular/core';
import { InstallationSignaturePluginService } from './signature.service';

@Pipe({
    name: 'signaturetype',
    standalone: false
})
export class SignatureTypePipe implements PipeTransform {
  public types: any;

  constructor(private service: InstallationSignaturePluginService) {
    this.types = this.service.getSignatureTypes();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.types);
  }
}
